import {
  INIT_SDK
} from './mutation-type' 

export default {
//--------------------------------vue仓库数据修改-----------------------------
    //存储个人信息
    setUserInfo(state,data){
        state.userInfo=data;
    },
    setLayout(state, data){
        if(data){
            state.navbarPosition = data
        }
    },
    setInformChange(state, data){
        if(data){
            state.informChange = data
        }
    },
	setSeriesList(state,data){
        state.seriesList=data;
    },
}




// WEBPACK FOOTER //
// ./src/store/mutations.js